import { useCallback, useState } from 'react';

export function usePagination(initialPage = 1) {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const hasNextPage = currentPage < totalPages;
  const hasPreviousPage = currentPage > 1;

  const nextPage = useCallback(() => {
    setCurrentPage((value) => value + 1);
  }, []);

  const previousPage = useCallback(() => {
    setCurrentPage((value) => value - 1);
  }, []);

  const setPage = useCallback((value: number) => {
    setCurrentPage(value);
  }, []);

  return {
    currentPage,
    totalPages,
    totalItems,
    hasNextPage,
    hasPreviousPage,
    nextPage,
    previousPage,
    setPage,
    setTotalPages,
    setTotalItems,
  };
}
